import { Component, OnInit,Input } from '@angular/core';
import {ModalController} from '@ionic/angular'
import { IonicSelectableComponent } from 'ionic-selectable';
import {ServicioLoadersAlertasService} from '../servicio-loaders-alertas.service'
import {GranServicioDePTWService} from '../gran-servicio-de-ptw.service'
import {ServicioPerfilDeAutoridadService} from '../servicio-perfil-de-autoridad.service'
import { Router } from '@angular/router';
import * as moment from 'moment'
import * as firebase from 'firebase'


//ionic-selectable
class Autoridad{
  public id: number;
  public name: string;
  public email: string;
  public regional: string
}


@Component({
  selector: 'app-modal-aprobacion',
  templateUrl: './modal-aprobacion.page.html',
  styleUrls: ['./modal-aprobacion.page.scss'],
})
export class ModalAprobacionPage implements OnInit {
  @Input()requiereAutoridadAislante
  @Input()requiereAutoridadElectrica
  @Input()requiereGerenteCampo
  @Input()nombreAutoridad

  //estos inputs son solo para validacion final de vistos buenos por AAL
  @Input()vistobuenoAutHSE
  @Input()vistobuenoAutElectrica
  @Input()vistobuenoAutAislante
  @Input()vistobuenoAutArea
  @Input()vistobuenoGerCampo

    //ionic-selectable
    listadeAutoridades: Autoridad[];
    listadeGerentesCampo: Autoridad[] = [];
    listadeAutoridadesAreaLocal: Autoridad[]; 

    comentario=''
    dictamenAutHSE={vistobueno:false,comentario:''}
    dictamenAutAmbiental={vistobueno:false,comentario:''}
    dictamenAutArea={vistobueno:false,comentario:''}
    dictamenAutAreaLocal={vistobueno:false,comentario:''}
    dictamenAutAislante={vistobueno:false,comentario:''}
    dictamenAutElectrica={vistobueno:false,comentario:''}
    dictamenGerenteCampo={vistobueno:false,comentario:''}
    autoridadseleccionada;
    gerenteCampoSeleccionado;
    // autoridadHSE={email:'',nombre:'',regional:''}
    // autoridadArea={email:'',nombre:'',regional:''}
    autoridadAreaLocal={email:'',nombre:'',regional:''}
    // autoridadAislante={email:'',nombre:'',regional:''}
    gerenteCampo={email:'',nombre:'',regional:''}

    logsAutAislante
    logsAutArea
    logsAutAreaLocal
    logsGerenteCampo

  constructor(public servicioLoadersAlertasService:ServicioLoadersAlertasService,public servicioPerfilDeAutoridadService:ServicioPerfilDeAutoridadService, public granServicioDePTWService:GranServicioDePTWService, private router:Router, private modalController:ModalController) { }

  ngOnInit() {
    if(this.servicioPerfilDeAutoridadService.autoridadArea ==true || this.servicioPerfilDeAutoridadService.gerenteCampo ==true){
     this. cargaAutoridadesAreaLocal()
    }
  }

  ionViewWillEnter(){

  }

  cargaAutoridadesAreaLocal(){
    return new Promise((resolve,reject)=>{
      this.servicioLoadersAlertasService.presentLoading("Cargando autoridades de área local / Loading local area authorities")
      this.listadeAutoridadesAreaLocal = [];
      let  query = firebase.firestore().collection("autoridades").where("autoridadAreaLocal","==",true)
       query.get().then((docs) => {
         docs.forEach((doc) => {
            this.listadeAutoridadesAreaLocal.push( { id:this.listadeAutoridadesAreaLocal.length-1 , name: doc.data().nombre, email: doc.data().email, regional:doc.data().regional } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto
         });
       }).then(()=>{
        this.servicioLoadersAlertasService.loadingController.dismiss()
        resolve("OK AAL")
       }).catch((err) => {
        reject(err)
         console.log(err);
       });
    })
  }

  cargaGerentesCampo(){
    if(this.listadeGerentesCampo.length==0){//ponemos el condicional para que solo se haga el cargue si no está cargada antes para que no se haga lectura cada vez que se toque
      this.servicioLoadersAlertasService.presentLoading("Cargando gerentes de campo / Loading field managers")
      this.listadeGerentesCampo = [];
      let  query = firebase.firestore().collection("autoridades").where("gerenteRegional","==",true)
      query.get().then((docs) => {
        docs.forEach((doc) => {
            this.listadeGerentesCampo.push( { id:this.listadeGerentesCampo.length-1 , name: doc.data().nombre, email: doc.data().email, regional:doc.data().regional } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto
        });
        this.servicioLoadersAlertasService.loadingController.dismiss()
      }).then(()=>{
        this.servicioLoadersAlertasService.loadingController.dismiss()
      }).catch((err) => {
        console.log(err);
      });
    }
  }



  aprobacionfinal(){


  //SI ES AUTORIDAD AISLANTE
  if(this.servicioPerfilDeAutoridadService.autoridadAislante==true){
    this.dictamenAutAislante.vistobueno=true;
    this.dictamenAutAislante.comentario=this.comentario;
    
    let objetodeupdate={
      dictamenAutAislante:this.dictamenAutAislante,
      logsAutAislante: firebase.firestore.FieldValue.arrayUnion({comentario:this.comentario,fecha:moment().format('YYYY-MM-DD'),ejecutadoPor:firebase.auth().currentUser.email , accion:"Aprobado"})
            }
    this.updatefirebase(objetodeupdate)
  }else

  //SI ES AUTORIDAD ELECTRICA
  if(this.servicioPerfilDeAutoridadService.autoridadElectrica==true){

    this.dictamenAutElectrica.vistobueno=true;
    this.dictamenAutElectrica.comentario=this.comentario;
    
    let objetodeupdate={
      dictamenAutElectrica:this.dictamenAutElectrica,
      logsAutElectrica: firebase.firestore.FieldValue.arrayUnion({comentario:this.comentario,fecha:moment().format('YYYY-MM-DD'),ejecutadoPor:firebase.auth().currentUser.email , accion:"Aprobado"})
            }
    this.updatefirebase(objetodeupdate)
  }else
 //SI ES AUTORIDAD AMBIENTAL
  // if(this.servicioPerfilDeAutoridadService.autoridadAmbiental==true){

  //   this.dictamenAutAmbiental.vistobueno=true;
  //   this.dictamenAutAmbiental.comentario=this.comentario;
    
  //   let objetodeupdate={
  //     dictamenAutAmbiental:this.dictamenAutAmbiental,
  //     logsAutAmbiental: firebase.firestore.FieldValue.arrayUnion({comentario:this.comentario,fecha:moment().format('YYYY-MM-DD'),ejecutadoPor:firebase.auth().currentUser.email , accion:"Aprobado"})
  //           }
  //   this.updatefirebase(objetodeupdate)
  // }else




  //SI ES AUTORIDAD DE AREA:
  //si el usuario es autoridad de area Y NO SE REQUIERE GERENTE DE CAMPO, asigna la autoridad de area local
  if(this.servicioPerfilDeAutoridadService.autoridadArea==true){

    if(this.requiereGerenteCampo==false){

      this.validacamposAutAreaLocal()
      .then(()=>{
        this.dictamenAutArea.vistobueno=true;
        this.dictamenAutArea.comentario=this.comentario;
        let objetodeupdate={
          requiereGerenteCampo:false,
          dictamenAutArea:this.dictamenAutArea,
          logsAutArea: firebase.firestore.FieldValue.arrayUnion({comentario:this.comentario,fecha:moment().format('YYYY-MM-DD'),ejecutadoPor:firebase.auth().currentUser.email , accion:"Aprobado"}),
          autoridadAreaLocal:this.autoridadAreaLocal
        }
        this.updatefirebase(objetodeupdate)
      })
      .catch(()=>{
        this.servicioLoadersAlertasService.alerta("Autoridad de Área Local no ha sido asignada / Local area authority not assigned.","Seleccione una autoridad para continuar / Select a local area authority to continue")
      })
        
    }else
    //si SI se requiere gerente de campo, no asigna AAL porque esta la asigna el gerente de campo
    if(this.requiereGerenteCampo==true){

      this.validacamposGerCampo()
      .then(()=>{

        this.dictamenAutArea.vistobueno=true;
        this.dictamenAutArea.comentario=this.comentario;
        this.autoridadAreaLocal.email=''
        this.autoridadAreaLocal.nombre=''
        this.autoridadAreaLocal.regional=''
        let objetodeupdate={
          requiereGerenteCampo:true,
          dictamenAutArea:this.dictamenAutArea,
          logsAutArea: firebase.firestore.FieldValue.arrayUnion({comentario:this.comentario,fecha:moment().format('YYYY-MM-DD'),ejecutadoPor:firebase.auth().currentUser.email , accion:"Aprobado"}),
          gerenteCampo:this.gerenteCampo
        }
        this.updatefirebase(objetodeupdate)

      }).catch(()=>{
        this.servicioLoadersAlertasService.alerta("Gerente de campo no asignado / Field manager not assigned","Seleccione un gerente o desactive la opción de Gerente de Campo / Select a a field manager or disable the field manager option")
      })
    }
          

  }else

  //SI ES GERENTE DE CAMPO:
  //si el usuario es gerente de campo, asigna la autoridad de area local
  if(this.servicioPerfilDeAutoridadService.gerenteCampo==true){

    this.validacamposAutAreaLocal()
      .then(()=>{
          this.dictamenGerenteCampo.vistobueno=true;
          this.dictamenGerenteCampo.comentario=this.comentario;
          let objetodeupdate={
            dictamenGerenteCampo:this.dictamenGerenteCampo,
            logsGerenteCampo: firebase.firestore.FieldValue.arrayUnion({comentario:this.comentario,fecha:moment().format('YYYY-MM-DD'),ejecutadoPor:firebase.auth().currentUser.email , accion:"Aprobado"}),
            autoridadAreaLocal:this.autoridadAreaLocal             
          }
          this.updatefirebase(objetodeupdate)
      })
      .catch(()=>{
        this.servicioLoadersAlertasService.alerta("Autoridad de Área Local no ha sido asignada / Local area authority not assigned","Seleccione una autoridad para continuar / Select a local area authority to continue")
      })  
  }else

  
    //SI ES AUTORIDAD DE AREA LOCAL:, 
    if(this.servicioPerfilDeAutoridadService.autoridadAreaLocal==true){

      if(this.vistobuenoAutArea == true){
        //VALIDAMOS ANTES LOS DICTAMENES DE TODAS LAS AUTORIDADES:
        this.validacionFinalAprobaciones()
        .then(()=>{
          let fechahoy = moment().format('YYYY-MM-DD')
          let fechadevencimiento = moment(fechahoy, "YYYY-MM-DD").add(7, 'days')
          this.dictamenAutAreaLocal.vistobueno=true;
          this.dictamenAutAreaLocal.comentario=this.comentario;

          let objetodeupdate={
            dictamenAutAreaLocal:this.dictamenAutAreaLocal,
            logsAutAreaLocal: firebase.firestore.FieldValue.arrayUnion({comentario:this.comentario,fecha:moment().format('YYYY-MM-DD'),ejecutadoPor:firebase.auth().currentUser.email , accion:"Aprobado"}),
            fechavencimiento:moment(fechadevencimiento).format('YYYY-MM-DD'),
            timestampAprobacion:firebase.firestore.FieldValue.serverTimestamp(),
            status:"Aprobado",
          }
          this.updatefirebase(objetodeupdate)
        })
        .catch(()=>{
          this.servicioLoadersAlertasService.alerta("Autorización no permitida / Approval denied","Hay autoridades que no han aprobado este permiso. Asegúrese de que cada autoridad haya aprobado e intente de nuevo.  /  One or more authorities have not yet approved this permit. Make sure all authorities have approved the permit and try again.")
        })
      }
      else{
        this.servicioLoadersAlertasService.alerta("Autorización no permitida / Approval denied","La autoridad de área no ha aprobado este permiso. Asegúrese de que cada autoridad haya aprobado e intente de nuevo.  /  Area authority has not yet approved this permit. Make sure all authorities have approved the permit and try again.")
      }

      

    }
  }

  gerenteCampoToggle(){
    if(this.requiereGerenteCampo == false){
      this.gerenteCampo.email=''
      this.gerenteCampo.nombre=''
      this.gerenteCampo.regional=''
    }
  }

  gerenteCampoChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    this.gerenteCampo.email = event.value.email
    this.gerenteCampo.nombre = event.value.name
    this.gerenteCampo.regional = event.value.regional
  }

  autoridadAreaLocalChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    this.autoridadAreaLocal.email = event.value.email
    this.autoridadAreaLocal.nombre = event.value.name
    this.autoridadAreaLocal.regional = event.value.regional
  }





  validacamposGerCampo(){
    return new Promise ((resolve,reject)=>{
      if(this.requiereGerenteCampo == true && this.gerenteCampo.email !=''){
        resolve("OK")
      }else
      {
        reject()
      }
    })
   }

   validacamposAutAreaLocal(){
    return new Promise ((resolve,reject)=>{
      if(this.autoridadAreaLocal.email != ""){
        resolve("OK")
      }else
      {
        reject()
      }
    })
   }

  
   validacionFinalAprobaciones(){

    return new Promise ((resolve,reject)=>{
      if(!this.requiereAutoridadElectrica && !this.requiereAutoridadAislante && !this.requiereGerenteCampo){ // X X X
        resolve("OK")
      }else
      if(this.requiereAutoridadElectrica && this.requiereAutoridadAislante && this.requiereGerenteCampo){   // O O O
        if(this.validaAutElectrica() && this.validaAutAislante() && this.validaGerenteCampo){resolve("OK")}else{reject()}
      }else
      if(!this.requiereAutoridadElectrica && this.requiereAutoridadAislante && this.requiereGerenteCampo){ // X O O
        if(this.validaAutAislante() && this.validaGerenteCampo()){resolve("OK")}else{reject()}
      }else
      if(this.requiereAutoridadElectrica && !this.requiereAutoridadAislante && this.requiereGerenteCampo){ // O X O
        if(this.validaAutElectrica() && this.validaGerenteCampo()){resolve("OK")}else{reject()}
      }else
      if(this.requiereAutoridadElectrica && this.requiereAutoridadAislante && !this.requiereGerenteCampo){ // O O X
        if(this.validaAutElectrica() && this.validaAutAislante()){resolve("OK")}else{reject()}
      }else
      if(this.requiereAutoridadElectrica && !this.requiereAutoridadAislante && !this.requiereGerenteCampo){ // O X X
        if(this.validaAutElectrica()){resolve("OK")}else{reject()}
      }else
      if(!this.requiereAutoridadElectrica && this.requiereAutoridadAislante && !this.requiereGerenteCampo){ // X O X
        if(this.validaAutAislante()){resolve("OK")}else{reject()}
      }else
      if(!this.requiereAutoridadElectrica && !this.requiereAutoridadAislante && this.requiereGerenteCampo){ // X X O
        if(this.validaGerenteCampo()){resolve("OK")}else{reject()}
      }

  
    })  
   }

  validaAutAislante(){
    if(this.requiereAutoridadAislante && this.vistobuenoAutAislante){
        return true
    }
  }

  validaAutElectrica(){
    if(this.requiereAutoridadElectrica && this.vistobuenoAutElectrica){
      return true
    }
  }

  validaGerenteCampo(){
    if(this.requiereGerenteCampo && this.vistobuenoGerCampo){
      return true
    }
  }





  updatefirebase(objetodeUpdate){
    console.log("IDSOLICITUD"+this.granServicioDePTWService.idSolicitud)
    firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update(objetodeUpdate).then(()=>{
        this.servicioLoadersAlertasService.alerta("Solicitud aprobada / Request approved","La solicitud ha sido marcada como aprobada. ¡Gracias! / The request has been marked as approved. Thank you!");
    }).then((doc)=>{
      this.modalController.dismiss()
      this.navegar('/menu')
    })
  }

  navegar(entrada){
    this.router.navigateByUrl(entrada);
 } 

 cancelar(){
   this.modalController.dismiss()
 }
  



}//fin de clase
